import { adjacentLevels } from '../Buttons/colorVariants'

function useColorLevel(level) {
    return adjacentLevels(level)
}

export default useColorLevel
